import React, { useEffect, useState } from "react";
import "./EnvComponent.scss"; // Import SCSS file
import Home from "../Home/Home";
import { CartData } from "../../interfaces/CartData";
import { useNavigate } from "react-router-dom";
import { useHeaderMenu } from "../../contexts/login.context";
import useLoader from '../../contexts/LoaderContext';
import Spinner from "../Spinner/Spinner";
import { useTranslation } from "react-i18next";
import nvCookieHelpers from "../../services/cookieService";
import { useCart } from "../../services/cartService";
import { config } from "../../config";
import { useAuth } from '../../services/authService';

const EnvComponent = () => {
  const [data, setData] = useState<CartData | null>(null);
  const locale = window.location.pathname.split('/')[1];
  const { showLoader, hideLoader, isLoading, hideBodyLoader } = useLoader();
  const { setItemsInCart } = useHeaderMenu();
  const { getCart } = useCart();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { HandleSSOLogin } = useAuth();
  const [loggedIn, setLoggedIn] = useState(false);
  const registeredShopperAPI = config.registeredShopperAPI;
  const emptyCart = (msg, pid?) => navigate(`/${locale}/cart/empty`, { state: { msg, pid } });
  const orderAccount = () => {
    window.location.href = config.bcOrdersUrl
  }

  const handleSuccess = (result, pid?) => {
    let resultLength = Object.keys(result.cartItems).length
    if (result && resultLength > 0) {
      setData(result)
    } else {
        if (nvCookieHelpers.getCookie('isUserLoggedIn')) {
          orderAccount();
        } else {
          handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'), pid);
        }
    }
  }
  const handleError = (str: string, pid?: number) => {
    if (pid) {
      if (str && str.length) {
        emptyCart(str, pid);
      } else {
        emptyCart(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'), pid);
      }
    } else {
      emptyCart(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
    }
    setItemsInCart(0);
    hideBodyLoader();
  };
  const handleSubmit = (btnType: string) => {
    if (btnType) {
      navigate(`/${locale}/cart/user/${btnType}`);
      sessionStorage.setItem('customer', btnType);
    } else {
      // Navigate to another route
      navigate(`/${locale}/cart/`);
    }
  };
  useEffect(() => {
    async function fetchData() {
      try {
        showLoader();
        fetch(registeredShopperAPI, {
          credentials: 'include',
        }).then(async (res) => {
          await HandleSSOLogin(handleSubmit, () => { })
          await getCart(handleSuccess, handleError, true);
          const isUserLoggedIn = nvCookieHelpers.getCookie('isUserLoggedIn');
          if (isUserLoggedIn && Boolean(isUserLoggedIn)) {
            setLoggedIn(true);
            hideLoader();
          } else {
            hideLoader();
          }
        });
      } catch (error) {
        console.error(error);
        emptyCart(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
      }
    }
    if (!data) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="env-component">
      {
        isLoading ? (
          <Spinner />
        ) : (
          <div className="viewPage">
            {data && (
              <Home cartData={data} loggedIn={loggedIn} />
            )}
          </div>
        )}
    </div>
  );

}

export default EnvComponent;
